import React from 'react';

function TopBar({ title, onBack }) {
  return (
    <div className="w-full flex items-center justify-between px-4 py-3 bg-white dark:bg-dark-surface shadow-sm sticky top-0 z-10">
      <div className="flex items-center gap-3">
        {onBack && (
          <button onClick={onBack} className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-dark-surfaceHover dark:text-dark-text">←</button>
        )}
        <div className="text-lg font-semibold dark:text-dark-text">{title}</div>
      </div>
      <div className="text-xs text-gray-500 dark:text-dark-textSecondary">Elements</div>
    </div>
  );
}

export default TopBar;
